// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3bV-b","visuallyhidden":"vkEor","hide-text":"_CB3w","center":"_1QaDS","noprint":"_22-Ka","load-comments":"_2pcvK","comments-closed-heading":"hTvxL","comments-closed-text":"_3nUgQ","closing-info-wrapper":"_2eHwT","closing-info":"_1zAOW"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-fb-comments/styles/default.scss
 ** module id = 999
 ** module chunks = 2
 **/